export default __webpack_public_path__ + "static/media/rating25.c480430e.svg";